let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aIud5")).then(() => parcelRequire('2iaUR'));